export interface PresetSuggestion {
  value: string;
  label?: string;
  category?: string;
}

export const SUFFIX_PREFIX_PRESETS = Object.freeze([
  Object.freeze({ value: '€', label: '€', category: 'currency' as const }),
  Object.freeze({ value: '$', label: '$', category: 'currency' as const }),
  Object.freeze({ value: '₽', label: '₽', category: 'currency' as const }),
  Object.freeze({ value: '¥', label: '¥', category: 'currency' as const }),
  Object.freeze({ value: '%', label: '%', category: 'percentage' as const }),
]);
